import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import {RouterModule} from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import {MatProgressSpinnerModule, MatSnackBarModule} from '@angular/material';
import { PhoneMaskDirective } from './_helpers/directives/phone-mask.directive';
import {ZipcodeDirective} from './_helpers/directives/zipcode.directive';
import { ErrorMessageComponent } from './_helpers/components/error-message.component';
import {ContrackCommonModule} from './contrack-common.module';
import {ResultMessageComponent} from "./_helpers/components/result-message.component";
import {CancelButtonComponent} from "./_helpers/components/cancel-button.component";
import {ImageViewerComponent} from "./_helpers/components/image-viewer.component";
import {BackButtonComponent} from "./_helpers/components/back-button.component";

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    PhoneMaskDirective,
    ZipcodeDirective,
    ErrorMessageComponent,
    ResultMessageComponent,
    CancelButtonComponent,
    BackButtonComponent,
    ImageViewerComponent
  ],
  entryComponents: [
    ErrorMessageComponent,
    ResultMessageComponent,
    ImageViewerComponent
  ],
  imports: [
    CommonModule,
    ContrackCommonModule,
    MatProgressSpinnerModule,
    RouterModule
  ],
  exports: [
    ContrackCommonModule,
    HeaderComponent,
    SidebarComponent,
    PhoneMaskDirective,
    ZipcodeDirective,
    MatSnackBarModule,
    ErrorMessageComponent,
    CancelButtonComponent,
    BackButtonComponent
  ]
})
export class SharedModule { }
